import { FormSchema } from "../../../interfaces/components/form";
import { FormComponent } from "../../../components/form/FormComponents";

export const addNewPatient: FormSchema = {
  type: "object",
  properties: {
    first_name: {
      label: "First Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Enter first name",
        type: "text",
      },
    },
    last_name: {
      label: "Last Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Enter last name",
        type: "text",
      },
    },
    email: {
      label: "Email Address",
      type: "email",
      format: "email",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "patient@email.com",
        type: "email",
      },
    },
    dob: {
      label: "Date of Birth",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      componentProps: {
        placeholder: "Select date of birth",
        showTime: false,
      },
    },
    gender: {
      label: "Gender",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Gender",
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
          { label: "Other", value: "other" },
        ],
      },
    },
    blood_type: {
      label: "Blood Type",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Blood Type",
        options: [
          { label: "A+", value: "A+" },
          { label: "A-", value: "A-" },
          { label: "B+", value: "B+" },
          { label: "B-", value: "B-" },
          { label: "AB+", value: "AB+" },
          { label: "AB-", value: "AB-" },
          { label: "O+", value: "O+" },
          { label: "O-", value: "O-" },
        ],
      },
    },
  },
}; 